import React, { Fragment } from 'react';
import { Placeholder } from 'semantic-ui-react';
import ReactApexChart from 'react-apexcharts';
import {
    Bar,
    BarChart,
    CartesianGrid,
    Cell,
    Legend,
    Pie,
    PieChart as PC,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis
} from 'recharts';
import { center, customLabel, CountriesColors as colors, legendStyle } from '../../../Statistics/util';


// eslint-disable-next-line import/prefer-default-export
/**
data = [{dataKey : 1, nameKey: 'name'}, {dataKey : 1, nameKey: 'name'}]
 * */

// eslint-disable-next-line import/prefer-default-export
export const PieChart = ({
    series, options, data, colors
}) => (
    <ReactApexChart options={options} series={series} type="pie" width="500" />

);



// WEBPACK FOOTER //
// ./src/views/StudentService/Reports/ConstReports/PieChart.js